// Like Button Component for tutorial videos
// Shows like count and allows users to like/unlike videos
// Uses thumbs up icon and integrates with LearnManager

import React, { useState, useEffect } from 'react';

export function LikeButton({
  videoId,
  initialLikes = 0,
  initialLiked = false,
  manager,
  className = ''
}) {
  const [likes, setLikes] = useState(initialLikes);
  const [isLiked, setIsLiked] = useState(initialLiked);
  const [isLoading, setIsLoading] = useState(false);

  // Update state when props change (e.g., when video data loads)
  useEffect(() => {
    setLikes(initialLikes);
    setIsLiked(initialLiked);
  }, [initialLikes, initialLiked]);

  const handleLikeToggle = async () => {
    if (!manager || isLoading) return;

    setIsLoading(true);
    try {
      // Let the backend handle the toggle logic
      const result = await manager.toggleLikeVideo(videoId);
      setLikes(result.likes);
      setIsLiked(result.liked);
    } catch (error) {
      console.error('Failed to toggle like:', error);
      // Don't revert state on error since backend controls the logic now
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <button
      className={`learn-qa-helpful ${isLiked ? 'liked' : ''} ${className}`}
      onClick={handleLikeToggle}
      disabled={isLoading || !manager}
      title={isLiked ? 'Unlike this video' : 'Like this video'}
    >
      <i className={`fa-solid fa-thumbs-up ${isLoading ? 'fa-spin' : ''}`}></i> {likes} found this helpful
    </button>
  );
}